var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"booking-page"},[_c('booking-filters'),_vm._v(" "),_c('booking-list'),_vm._v(" "),_c('info-widget',{ref:"infoWidget",attrs:{"tips":_vm.tips}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e295ebb6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BookingPage/BookingPage.vue
// module id = null
// module chunks = 